export enum WISH_LIST_OFF_CANVAS_IDS {
  CREATE_WISH_LIST = 'create-new-list-from-update-product',
  CREATE_WISH_LIST_MY_LISTS = 'create-new-list-from-my-lists',
  DELETE_WISH_LIST_MY_LISTS = 'delete-list-from-my-lists',
  PRODUCT_UPDATE = 'update-product-in-wish-list',
  DOWNLOAD_WISH_LIST_ITEMS = 'download-wish-list-items',
  DELETE_WISH_LIST = 'delete-list-from-update-product',
  DELETE_WISH_LIST_FROM_REVIEW = 'delete-list-from-review',
  DOWNLOAD_WISH_LIST_FROM_REVIEW = 'download-list-from-review',
  REVIEW_WISH_LIST = 'review-wish-list-from-update-product',
  UPDATE_WISH_LIST = 'update-list-from-update-product',
  UPDATE_WISH_LIST_FROM_REVIEW = 'update-wish-list-from-review',
  UPDATE_WISH_LIST_ITEM = 'update-list-from-list-item',
  UPDATE_WISH_LIST_MY_LISTS = 'update-list-from-my-lists',
}
